/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import BaseMedicalHistoryFormComponent from "parog-web/components/medical-history/abstract/base-edition-form";
import MedicalHistoryBaseEditionForm from "../base-edition-form";

export default class MedicalHistoryFormComponent extends BaseMedicalHistoryFormComponent {
  MedicalHistoryBaseEditionForm = MedicalHistoryBaseEditionForm;

  journalEventProperties = [
    ...this.sharedProperties,
    "diagnosisDate",
    "prType",
    "boneErosion",
    "erosionDiagnosisDate",
    "facteurRhumatoidesValue",
    "facteurRhumatoidesDate",
    "antiCppValue",
    "antiCppDate",
    "anticorpsAntiNucleairesValue",
    "anticorpsAntiNucleairesDate",
    "serologieHivValue",
    "serologieHivDate",
    "antigeneHbsValue",
    "antigeneHbsDate",
    "anticorpsAntiHbsValue",
    "anticorpsAntiHbsDate",
    "anticorpsAntiHbcValue",
    "anticorpsAntiHbcDate",
    "serologieHepatiteCValue",
    "serologieHepatiteCDate",
    "electropheresValue",
    "electropheresDate",
    "quantiferonValue",
    "quantiferonDate"
  ];
}
